import { ProseTheme } from '@/components/Prose/theme';
import { tw } from 'lib/utils/tw';

const RichTextBox = tw.theme({
  extend: ProseTheme,
  base: 'p-6',
});

export default RichTextBox;
